<script>
  
  import Select from 'svelte-select';
  import WhatsNew from '../modals/WhatsNew.svelte';
  import { onMount, afterUpdate } from 'svelte';
  import { Popover, Badge } from 'sveltestrap';
  import http from '../api/http.js';
  import { loggedIn, selectedGroup, groupHasSubbedVessels, userSettings, allGroups, branding} from '../store.js';
  import UserSettingsModal from '../modals/UserSettingsModal.svelte';
  import Events from '../componentcontent/SignalREvent.svelte';
  import moment from 'moment';
  import fromNow from 'fromNow';

  let open = false;

  let whatsNewInstance;

  let notificationsGrouped = [];
  let username = '';
  let selected = '';
  let groups = [];
  let userSettingsModal;
  const groupBy = (item) => item.group;
  
  let version = "Unknown";

  async function handleSelect(selected) {
    selectedGroup.set(selected.value);
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/containsubsribedvessel/${selected.value}`);
    groupHasSubbedVessels.set(await res.json());
  }
  	
  onMount(async () => {    
    if($loggedIn){
      await loadGroups();
      if($selectedGroup != null && $selectedGroup != 'null' && $selectedGroup != 0){
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/containsubsribedvessel/${$selectedGroup}`);
        groupHasSubbedVessels.set(await res.json());
        await loadUserSettings();
        await loadUserNotifications();
      }
    }
  });
  async function markAsViewed(notifications, clearType){
    try {      
      var notificationsToEdit = [];
      if(clearType == "clearAll"){
        notificationsGrouped.forEach(notificationSet => {
          notificationSet.forEach(notification => {
            notificationsToEdit.push(notification);
          });            
        });
      }else if(clearType == "clearSingle"){
        notificationsToEdit.push(notifications);     
      }
      else if(clearType == "clearGroup"){
        notifications.forEach(notification => {
            notificationsToEdit.push(notification);
        });           
      }      
      const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/notifications/${$selectedGroup}/markviewed`, notificationsToEdit);      
      await loadUserNotifications();
    } catch(error){
      console.error(error);
    }      
  }

  async function loadUserNotifications(){
    try {
      const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/notifications/${$selectedGroup}/getnotifications`);
      notificationsGrouped = await res.json();      
    } catch(error){
      console.error(error);
    }      
  }

  

  async function loadUserSettings(){
    try {
      const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/user/${$selectedGroup}/getsettings`);
      userSettings.set(await res.json());      
    } catch(error){
      console.error(error);
    }      
  }

  async function editUserSettings(data){
    try {
      if (data && data.detail && data.detail.settings) {        
        const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/user/${$selectedGroup}/editsettings`, data.detail.settings);        
        await loadUserSettings();        
      }      
    } catch(error){
      console.error(error);
    }      
  }

  async function loadGroups(){
    try {
      const res = await http.get(window.apiBaseUrl + '/deploy/dashboard/groups');
        
        if(res.status == 200){
          var groupData = await res.json(); 
          groups = groupData.item2;
        }
        if (groups.length > 0 && ($selectedGroup == "null" || $selectedGroup == null)) {
          selected = groups[groups.findIndex(group => group.value == groupData.item1)];
          handleSelect(groupData.item1)
        }else{
          selected = groups[groups.findIndex(g => g.value == $selectedGroup)];        }
        allGroups.set(groups.map(function(g){return g.value}));
    } catch (error) {
      console.error(error);
      groups = [];
    }

    var userRes = await http.get(window.apiBaseUrl + '/auth/username');

      
    if(userRes.status == 200){
      username = await userRes.text();
    }      
  }
  
  function getNotificationType(status){
    var retval;    
    if (status == 0){
      retval = "Software"
    }
    if (status == 1){
      retval = "Deployment"
    }    
    if (status == 2){
      retval = "Installation"
    }   
    if (status == 3){
      retval = "DataTransfer"
    }   
    return retval;
  }  

  function GetFromNow(dbdate)
  {  
    var date = new Date(dbdate);
    var offset = date.getTimezoneOffset();  
    let momentDate = moment(date).subtract(offset, 'm')
    return momentDate.fromNow();
  }

      

</script>

<style>
  .navbar {
  /* min-height: 100px; */
  height:60px;
  }
  #groupMenu {
    display: block;
    width: 25%;
    color:black;
    margin-left: 10px;    
  }
  
  .navMargin{
    margin-bottom: 20px;
  }
  .settingsCog{    
    cursor: pointer;
  }
  .notificationBell{
    padding-right: 3px;
    cursor: pointer; 
  }
  .pointer{
    cursor: pointer;    
  }
  .pointer:hover{
    font-weight: bold;
  }
  
  #NavbarRightContent{    
    width: 300px;
    padding-right:25px;
  }
  .notificationContent{
    width: 100%;
    border-bottom: 1px solid lightgrey;
    padding-bottom: 10px;
    padding-top: 10px;

  }
  
  .notificationText{
    padding: 0px 5px !important;
    width:200px;
    
  }
  .flex-parent-element {
  display: flex;
  margin-right:19px;
}

.flex-child-element {
  flex: 1;  
}

.flex-child-element:first-child {
  margin-right: 5px;
}


  #NotificationContentWrapper{
    max-height: 260px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #858796 whitesmoke;   
    padding: 0px 0px 0px 0px !important; 
    width:266px;
  }

  #NotificationContentWrapper:first-child{
    padding-top: 10px;
  }
  .notificationContent:last-child{
    padding-bottom: 10px;
    border-bottom: 0px none;
  }

  #clickOffComponent{
    position: absolute;
    top: 0;
    left: 0;
    width:100%;
    Height:100%;
    z-index: 10;
  }

  ::-webkit-scrollbar {
  width: 10px;
  z-index: 2;
}
::-webkit-scrollbar-track {
  background: whitesmoke;
  z-index: 2;
}
::-webkit-scrollbar-track-piece{
  background: whitesmoke;
  z-index: 2;
}

::-webkit-scrollbar-thumb {
  background: #858796;
  z-index: 2;
}
.notificationBadge{
  position: absolute;
  border-radius: 50%;
  background-color: red;
  color: white;
  text-align: center;
  width:12px;
  height:12px;
  font-size: 10px;
  display:block;
  margin-top:-18px;
  margin-left:8px;
  z-index: 1;  
}
.times{
  padding-right: 5px;
}
.notificationTime{
  position:relative;
  top: -10px;
  padding-right: 5px;
}
.notificationContent:last-child .notificationTime{
  position:relative;
  top: -5px !important;
  padding-right: 5px;
}

.notificationTypeIcon{
  padding-left:5px;
}

#full-logo-container{
  height: 100%;
  width: 200px;
  justify-content: center;
  display: flex;
  align-items: center;
  border-left: 1px solid #dedede;
}

#full-logo-container img{
    width: 55%;
}

.navbar{
  padding: 0px 0px 0px 0px !important;
}
</style>

<!-- <Events on:NotificationsUpdate={ loadUserNotifications }/> -->

<nav class="navbar navbar-expand navbar-light bg-white topbar static-top shadow d-flex">
    <div class="row w-25"> 
      <div class="col ml-2">
        <Select id="groupOptions" isClearable={false} isSearchable={true} bind:selectedValue={selected} on:select={() => handleSelect(selected)} items={groups} {groupBy}></Select>
      </div>       
    </div>

    <div  class="d-flex ml-auto">  
      <div class="d-flex align-items-center mr" >
        <div class="mr-2">{username}</div>
        <i class="fa fa-question-circle pointer mr-2" on:mousedown={whatsNewInstance.show()}></i>
        <i id="notificationBtn" tabindex="0" class="fas fa-bell notificationBell mr-2">{#if notificationsGrouped.length > 0 && notificationsGrouped.length < 10}<div class="notificationBadge">{notificationsGrouped.length}</div>{:else if notificationsGrouped.length >= 10}<div class="notificationBadge">9+</div>{/if}</i>
        <i class="fas fa-cog settingsCog mr-2" on:click={() => userSettingsModal.show()}></i>
      </div>

      {#if $branding.logoOnly}
        <div id="full-logo-container">
          <img alt="{$branding.name}" src="/themes/{$branding.theme}/product-secondary.png">
        </div> 
      {/if}
 
    <UserSettingsModal on:confirm={(data) => editUserSettings(data)} bind:this={userSettingsModal}></UserSettingsModal>
  </div>  
</nav>
<div class="navMargin"></div>
{#if open}
  <div id="clickOffComponent" on:click={() => open = false}></div>
{/if}
<Popover placement="bottom" target="notificationBtn" bind:isOpen={open}>
  <div slot="title">
    <b>Notifications</b><small class="float-right text-primary pointer" on:click={()=> markAsViewed(notificationsGrouped, "clearAll")}>Clear All</small>
  </div>
  <div id="NotificationContentWrapper">    
    {#each notificationsGrouped as notificationSet}      
          {#if notificationSet.length < 5}
            {#each notificationSet as notification}
              <div class="notificationContent">
                <div class="float-right pointer times" on:click={()=> markAsViewed(notification, "clearSingle")}>&times;</div> 
                <div class ="notificationText flex-parent-element">
                  {#if getNotificationType(notification.notificationType) == "Software"}
                    <div><i class="fas fa-tasks notificationTypeIcon flex-child-element"></i></div>
                    <div class="flex-child-element">                      
                      <b>{notification.packageVersion.displayName}</b><br>
                      {#if notification.successful}Has been built and is <b>ready</b> for use.{:else}Has <b>failed</b> to build.{/if}                                          
                  </div>                  
                  {:else if getNotificationType(notification.notificationType) == "Deployment"}                    
                  <div><i class="fas fa-ship notificationTypeIcon flex-child-element"></i></div>
                  <div class="flex-child-element">                    
                    <b>{notification.packageVersion.displayName}</b><br>
                    {#if notification.successful}Has been deployed to <b>{notification.vessel.account}</b>.{:else}Deployment to {notification.vessel.account} has <b>failed</b> to build.{/if}
                  </div> 
                  {:else if getNotificationType(notification.notificationType) == "Installation"}                    
                    <div><i class="fas fa-desktop notificationTypeIcon flex-child-element"></i></div>
                    <div class="flex-child-element">
                      <b>{notification.packageVersion.displayName}</b><br>
                      {#if notification.successful}Has been installed on <b>{notification.computer.hostName}</b>.{:else}Installation on {notification.computer.hostName} has <b>failed</b>.{/if}
                    </div>    
                    {:else if getNotificationType(notification.notificationType) == "DataTransfer"}                    
                    <div><i class="fas fa-chevron-double-right notificationTypeIcon flex-child-element"></i></div>
                    <div class="flex-child-element">
                      <b>{notification.packageVersion.displayName}</b><br>
                      {#if notification.successful}Data has been transferred to <b>{notification.computer.hostName}</b>.{:else}Data transfer on {notification.computer.hostName} has <b>failed</b>.{/if}
                    </div>   
                  {/if}  
                </div>   
                <div><small class="float-right notificationTime">{GetFromNow(notification.created)}</small></div>              
              </div>        
            {/each}            
          {:else}
            <div class="notificationContent">
              <div class="float-right pointer" on:click={()=> markAsViewed(notificationSet, "clearGroup")}>&times;</div>
              <div class ="notificationText flex-parent-element">
                {#if getNotificationType(notificationSet[0].notificationType) == "Deployment"}
                  <div><i class="fas fa-ship notificationTypeIcon flex-child-element"></i></div>
                  <div class="flex-child-element">                    
                    <b>{notificationSet[0].packageVersion.displayName}</b><br>
                    {#if notificationSet[0].successful}Has been deployed to <b>{notificationSet.length} vessels</b>.{:else}Has <b>failed</b> to deploy to {notificationSet.length} vessels.{/if}
                  </div>     
                {:else if getNotificationType(notificationSet[0].notificationType) == "Installation"} 
                  <div><i class="fas fa-desktop notificationTypeIcon flex-child-element"></i></div>
                  <div class="flex-child-element">                    
                    <b>{notificationSet[0].packageVersion.displayName}</b><br>
                    {#if notificationSet[0].successful}Has been installed on <b>{notificationSet.length} computers</b>.{:else}Has <b>failed</b> to install on {notificationSet.length} computers.{/if}
                  </div>  
                  {:else if getNotificationType(notificationSet[0].notificationType) == "DataTransfer"} 
                  <div><i class="fas fa-chevron-double-right notificationTypeIcon flex-child-element"></i></div>
                  <div class="flex-child-element">                    
                    <b>{notificationSet[0].packageVersion.displayName}</b><br>
                    {#if notificationSet[0].successful}Data has been transferred to <b>{notificationSet.length} computers</b>.{:else}Data transfer has <b>failed</b> on {notificationSet.length} computers.{/if}
                  </div>      
                {/if}
              </div>
              <div><small class="float-right notificationTime">{GetFromNow(notificationSet[notificationSet.length - 1].created)}</small></div>
            </div>            
          {/if}
    {/each}       
    {#if notificationsGrouped.length == 0}<p class="notificationText">No notifications to display.</p>{/if}
  </div>
</Popover>

<WhatsNew bind:this={whatsNewInstance}></WhatsNew>